import { downgradeInjectable } from '@angular/upgrade/static';
import { AuthService } from '@fry-it/risr-core';

(function() {
  'use strict';

  angular.module('blocks.auth')
    .service('AuthService', downgradeInjectable(AuthService));
})();
